import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicAppetiteControlCombined from "./index";

const CardiometabolicAppetiteControlWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicAppetiteControlCombined}
    keyControlsId="appetite-control-key"
    {...props}
  />
);

export default CardiometabolicAppetiteControlWithToggleKey;
